import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import noImage from "../../no_Image.jpg";
import { useSelector, useDispatch } from "react-redux";
import {
  counterSlice,
  updateComparisonData,
} from "../../app/features/counter/counterSlice";
import "../../index.css";
import {
  setSelectedHardWare,
  setFinalData,
  deleteSelectedHardware,
  updateHardware2,
} from "../../app/features/counter/counterSlice";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { CategoryCsvData } from "../fetchData/CategoryCsvData.js";
import { ProductCsvData } from "../fetchData/ProductCsvData.js";
import { ProductOptionsCsvData } from "../fetchData/ProductOptionsCsvData.js";
import DisplayDrops from "./DisplayDrops.js";
import WarningComponent from "./WarningComponent.js";
import { calculateLineItem, getOptionEntries, getProductSku, getProductDisplayName } from "./quoteCalculator";

function MyVerticallyCenteredModal({
  show,
  onHide,
  customData,
  showButtons,
  totalSelectedCameras,
  productOptionCSVQuery,
}) {
  const selectedCameraNumber = useSelector(
    (state) => state.counter1.totalCamera
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );
  const drops = useSelector((state) => state.counter1.selectedDrops);

  const [count, setCount] = useState(
    customData.existingQuantity || drops[whichOption] || totalSelectedCameras
  );
  const [hardwareBasePrice, setHardwareBasePrice] = useState();
  const [basePrice3, setBasePrice3] = useState(
    customData.existingUnitCost || parseFloat(customData.price) || 0
  );
  const [unitCostInput, setUnitCostInput] = useState("");
  const [typedValue, setTypedValue] = useState(0);
  const [finalNewState, setFinalNewState] = useState({});
  const [HardWare_Final_Price, setHardWare_Final_Price] = useState([]);
  const [test, setTest] = useState(
    customData.existingTotalPrice ||
      parseFloat(customData.price) *
        (drops[whichOption] || totalSelectedCameras)
  );
  const [mergedState, setMergedState] = useState({});
  const [finalDatas, setFinalDatas] = useState([]);
  const [selectedOptionFields, setSelectedOptionFields] = useState({});

  const getHardwareCalc = (quantity = count, unitPrice = basePrice3, optionFields = selectedOptionFields) =>
    calculateLineItem({
      pricePerItem: Number(unitPrice || 0),
      quantity: Number(quantity || 0),
      ...optionFields,
    });

  const buildOptionGroups = (productId) => {
    const result = [];
    let currentArray = [];

    for (let i = 0; i < (productOptionCSVQuery || []).length; i += 1) {
      const option = productOptionCSVQuery[i];

      if (
        option.productid === productId ||
        (currentArray.length > 0 && option.productid === "")
      ) {
        currentArray.push(option);
      } else if (currentArray.length > 0) {
        result.push([...currentArray]);
        currentArray = [];
      }
    }

    if (currentArray.length > 0) {
      result.push([...currentArray]);
    }

    return result;
  };

  const handleOptionChange = (e) => {
    const { name, value } = e.target;
    const selectedOption = finalDatas
      .flat()
      .find(
        (option) =>
          option.featurecaption === name && option.featurename === value
      );

    const optionPrice = selectedOption
      ? parseFloat(selectedOption.featureprice) || 0
      : 0;

    setSelectedOptionFields((prev) => ({
      ...prev,
      [name]: value,
      [`${name}_price`]: optionPrice,
    }));
  };

  useEffect(() => {
    // Only update count from drops if we're adding a new item (not editing)
    if (showButtons !== "edit" && !customData.existingQuantity) {
      setCount(drops[whichOption] || totalSelectedCameras);
    }
  }, [
    whichOption,
    drops,
    customData.existingQuantity,
    totalSelectedCameras,
    showButtons,
  ]);

  useEffect(() => {
    if (show) {
      // Initialize all values only when modal opens
      const initialQuantity =
        customData.existingQuantity ||
        drops[whichOption] ||
        totalSelectedCameras;
      const initialPrice =
        customData.existingUnitCost || parseFloat(customData.price) || 0;

      setCount(initialQuantity);
      setBasePrice3(initialPrice);
      setHardwareBasePrice(parseFloat(customData.price) || 0);
      setTest(initialPrice * initialQuantity);

      const optionGroups = buildOptionGroups(customData.id);
      setFinalDatas(optionGroups);

      const initialOptions = {};
      optionGroups.forEach((group) => {
        if (group[0] && group[0].featurecaption) {
          const savedValue = customData[group[0].featurecaption];
          const savedPrice = customData[`${group[0].featurecaption}_price`];

          initialOptions[group[0].featurecaption] =
            savedValue || group[0].featurename;
          initialOptions[`${group[0].featurecaption}_price`] =
            savedPrice !== undefined
              ? Number(savedPrice || 0)
              : parseFloat(group[0].featureprice) || 0;
        }
      });

      setSelectedOptionFields(initialOptions);

      const initialCalc = calculateLineItem({
        pricePerItem: Number(initialPrice || 0),
        quantity: Number(initialQuantity || 0),
        ...initialOptions,
      });

      setFinalNewState({
        num_options: whichOption,
        uniqueID: customData.uniqueID,
        Product_Name: customData.id,
        Name: customData.name,
        HardWare_Base_Price: customData.price,
        Product_Quantity: initialQuantity,
        quantity: initialCalc.quantity,
        pricePerItem: initialCalc.unitPrice,
        totalPriceForItem: initialCalc.unitTotal,
        HardWare_Final_Price: initialCalc.lineTotal,
        Hardware_New_Final_Price: initialCalc.lineTotal,
        Hardware_Total_data: customData,
        basePrice3: initialCalc.unitPrice,
        ...initialOptions,
        ...(customData.drop ? { drop: customData.drop } : {}),
      });
    }
  }, [show, customData, productOptionCSVQuery]);

  useEffect(() => {
    setTest((typedValue + Number(HardWare_Final_Price)) * count);
  }, [HardWare_Final_Price, count, typedValue]);

  useEffect(() => {
    const calc = getHardwareCalc();

    setMergedState({
      ...finalNewState,
      Product_Quantity: count,
      quantity: calc.quantity,
      basePrice3: calc.unitPrice,
      pricePerItem: calc.unitPrice,
      totalPriceForItem: calc.unitTotal,
      test: calc.lineTotal,
      HardWare_Final_Price: calc.lineTotal,
      Hardware_New_Final_Price: calc.lineTotal,
      ...selectedOptionFields,
    });
  }, [count, basePrice3, finalNewState, selectedOptionFields]);

  const handlePlusClick = () => setCount(count + 1);
  const handleMinusClick = () => count > 1 && setCount(count - 1);
  const handlePlusClickByFive = () => setCount(count + 5);
  const handleMinusClickByFive = () => count > 5 && setCount(count - 5);
  const handlePlusClickByTen = () => setCount(count + 10);
  const handleMinusClickByTen = () => count > 10 && setCount(count - 10);

  const IncreaseByDollar_One = () => setTypedValue((prev) => prev + 1);
  const DecreaseByDollar_One = () =>
    typedValue > 0 && setTypedValue((prev) => prev - 1);

  const updateMergedState = () => {
    const calc = getHardwareCalc();

    setMergedState({
      ...finalNewState,
      Product_Quantity: count,
      quantity: calc.quantity,
      test: calc.lineTotal,
      HardWare_Final_Price: calc.lineTotal,
      Hardware_New_Final_Price: calc.lineTotal,
      basePrice3: calc.unitPrice,
      pricePerItem: calc.unitPrice,
      totalPriceForItem: calc.unitTotal,
      ...selectedOptionFields,
    });
  };

  const addHardWareButton = () => {
    mergedState.uniqueID =
      Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
    dispatch(setSelectedHardWare(mergedState));
    dispatch(setFinalData(mergedState));
    onHide(false);
  };

  const updateHardWare = () => {
    const calc = getHardwareCalc();
    const updatedState = {
      ...mergedState,
      Product_Quantity: count,
      quantity: calc.quantity,
      basePrice3: calc.unitPrice,
      pricePerItem: calc.unitPrice,
      totalPriceForItem: calc.unitTotal,
      test: calc.lineTotal,
      HardWare_Final_Price: calc.lineTotal,
      Hardware_New_Final_Price: calc.lineTotal,
    };
    dispatch(updateHardware2(updatedState));
    onHide(false);
  };

  const resetForm = () => {
    setFinalNewState({});
    setCount(drops[whichOption] || totalSelectedCameras);
    setBasePrice3(parseFloat(customData.price) || 0);
    setTest(
      parseFloat(customData.price) *
        (drops[whichOption] || totalSelectedCameras)
    );
    setTypedValue(0);
    setFinalDatas([]);
    setSelectedOptionFields({});
  };

  useEffect(() => {
    if (!show) {
      resetForm();
    }
  }, [show]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      setUnitCostInput(value);
      setBasePrice3(value === "" || value === "." ? 0 : parseFloat(value));
    }
  };

  const typedDecrement = () => {
    setUnitCostInput("");
    setBasePrice3((prev) => Math.trunc(prev - 1));
  };
  const typedIncrement = () => {
    setUnitCostInput("");
    setBasePrice3((prev) => Math.trunc(prev + 1));
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {customData.id}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col md={4}>
              <Row>
                <Card.Img
                  variant="top"
                  height={150}
                  src={
                    customData.thumbnail === ""
                      ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                      : "https://platinumcctv.com/" + customData.thumbnail
                  }
                />
              </Row>
              <Row className="my-2">
                {["image1", "image2", "image3"].map((img) => (
                  <Col key={img}>
                    <Card.Img
                      variant="top"
                      height={50}
                      src={
                        customData[img] === ""
                          ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                          : "https://platinumcctv.com/" + customData[img]
                      }
                    />
                  </Col>
                ))}
              </Row>
            </Col>
            <Col md={8}>
              <p>
                Product Description:
                {customData.description
                  ? customData.description
                  : customData.id}
              </p>
              {finalDatas.map((group, index) => (
                <React.Fragment key={group[0]?.featurecaption || index}>
                  <Form.Label>{group[0]?.featurecaption}</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    className="mb-3"
                    name={group[0]?.featurecaption}
                    value={selectedOptionFields[group[0]?.featurecaption] || ""}
                    onChange={handleOptionChange}
                  >
                    {group.map((option, optionIndex) => (
                      <option key={optionIndex} value={option.featurename}>
                        {option.featurename + " $ " + option.featureprice}
                      </option>
                    ))}
                  </Form.Select>
                </React.Fragment>
              ))}

              <div className="d-flex align-items-end justify-content-between my-4">
                Qty:
                <Button variant="dark" onClick={handleMinusClickByTen}>
                  -10
                </Button>
                <Button variant="dark" onClick={handleMinusClickByFive}>
                  -5
                </Button>
                <Button variant="dark" onClick={handleMinusClick}>
                  -
                </Button>
                <h6 className="mx-3">{count}</h6>
                <Button variant="dark" onClick={handlePlusClick}>
                  +
                </Button>
                <Button variant="dark" onClick={handlePlusClickByFive}>
                  +5
                </Button>
                <Button variant="dark" onClick={handlePlusClickByTen}>
                  +10
                </Button>
              </div>
              <hr />
              <div className="d-flex align-items-center justify-content-end">
                Unit Cost:
                <InputGroup className="mb-3">
                  <Button
                    variant="dark"
                    className="mx-3"
                    onClick={typedDecrement}
                  >
                    -
                  </Button>
                  <Form.Control
                    type="number"
                    value={unitCostInput !== "" ? unitCostInput : basePrice3}
                    onFocus={() => setUnitCostInput(String(basePrice3 ?? ""))}
                    onBlur={() => setUnitCostInput("")}
                    onChange={handleInputChange}
                  />
                  <Button
                    variant="dark"
                    className="mx-3"
                    onClick={typedIncrement}
                  >
                    +
                  </Button>
                </InputGroup>
              </div>
              <Row>
                <Col className="d-flex justify-content-end me-2">
                  <Row className="p-0">
                    <Col className="px-0">
                      <div className="mt-4">
                        <h6 className="fw-bold text-end">
                          Total Price: $
                          {getHardwareCalc().lineTotal
                            .toFixed(2)
                            .replace(/\.?0+$/, "")}
                        </h6>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="dark" onClick={onHide}>
          Back
        </Button>
        {showButtons === "edit" ? (
          <Button variant="dark" onClick={updateHardWare}>
            Update Hardware
          </Button>
        ) : (
          <Button variant="dark" onClick={addHardWareButton}>
            Add
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

function Hardware() {
  // Warning Model
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const cameraNumber = useSelector((state) => state.counter1.totalCamera);

  const [totalDrops, setTotalDrops] = useState(0);
  const [showWarningComponent, setShowWarningComponent] = useState(false);

  // Warning Model
  const dispatch = useDispatch();
  const areYouDealer = useSelector((state) => state.counter1.areYouDealer);

  const navigate = useNavigate();
  const selectedCameraNumber = useSelector(
    (state) => state.counter1.totalCamera
  );

  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );

  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);
  const selectedHardware = useSelector(
    (state) => state.counter1.selectedHardWare
  );

  const [showButtons, setShowButtons] = useState(null);

  const [modalShow, setModalShow] = React.useState(false);
  // UniverSal Data Starts
  const { categoryCSVQuery, isLoading1, isOnline, isError1 } =
    CategoryCsvData();
  const { productCSVQuery, isLoading2, isOnline2, isError2 } = ProductCsvData();
  const { productOptionCSVQuery, isLoading3, isOnline3, isError3 } =
    ProductOptionsCsvData();
  const [data2, setData2] = useState([]);

  function handleButtonClick(e, hardware, type, uniqueID = null) {
    // Reset modal state first
    setModalShow(false);

    // Use setTimeout to ensure the modal closes before reopening with new data
    setTimeout(() => {
      setShowButtons(type);
      setModalShow(true);

      let UpdateItem = [];
      if (type === "edit") {
        UpdateItem = Array.isArray(selectedHardware)
          ? selectedHardware.filter((item) => item.uniqueID === uniqueID)
          : [];
      }

      let newState = {
        id: type === "edit" ? UpdateItem[0]?.Product_Name : hardware.id,
        name: type === "edit" ? UpdateItem[0]?.Name : hardware.name,
        thumbnail:
          type === "edit" && UpdateItem[0] && UpdateItem[0].Hardware_Total_data
            ? UpdateItem[0].Hardware_Total_data.thumbnail
            : hardware?.thumbnail || "",
        image1:
          type === "edit" && UpdateItem[0] && UpdateItem[0].Hardware_Total_data
            ? UpdateItem[0].Hardware_Total_data.image1
            : hardware?.image1 || "",
        image2:
          type === "edit" && UpdateItem[0] && UpdateItem[0].Hardware_Total_data
            ? UpdateItem[0].Hardware_Total_data.image2
            : hardware?.image2 || "",
        image3:
          type === "edit" && UpdateItem[0] && UpdateItem[0].Hardware_Total_data
            ? UpdateItem[0].Hardware_Total_data.image3
            : hardware?.image3 || "",
        price:
          type === "edit" && UpdateItem[0]
            ? UpdateItem[0].basePrice3
            : areYouDealer !== "Dealer Selected"
            ? hardware?.price
            : hardware?.price_2,
        description: hardware?.description || "",
        uniqueID:
          type === "edit"
            ? UpdateItem[0]?.uniqueID
            : Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
        existingQuantity:
          type === "edit" ? UpdateItem[0]?.Product_Quantity : null,
        existingUnitCost: type === "edit" ? UpdateItem[0]?.basePrice3 : null,
        existingTotalPrice: type === "edit" ? UpdateItem[0]?.test : null,
      };

      if (type === "edit" && UpdateItem[0]) {
        Object.keys(UpdateItem[0]).forEach((key) => {
          if (
            ![
              "Product_Name",
              "Name",
              "Hardware_Total_data",
              "thumbnail",
              "image1",
              "image2",
              "image3",
              "price",
              "basePrice3",
              "Product_Quantity",
              "test",
              "uniqueID",
              "drop",
            ].includes(key)
          ) {
            newState[key] = UpdateItem[0][key];
          }
        });
      }

      if (hardware?.extra_field_2) {
        newState = {
          ...newState,
          drop: hardware.extra_field_2,
        };
      }

      setData2(newState);
    }, 100);
  }

  const hardwareData = productCSVQuery
    ? productCSVQuery.filter((item) => {
        if (item.categories === "Hardware") {
          if (areYouDealer === "Dealer Selected") {
            if (item.hide_2 === "0") {
              return item.categories
                .split("/")
                .some((word) => word === "Hardware");
            }
          } else if (areYouDealer !== "Dealer Selected") {
            if (item.hide_1 === "0") {
              return item.categories
                .split("/")
                .some((word) => word === "Hardware");
            }
          }
        }
        return false;
      })
    : [];
  // Delete Hardware

  function deleteHardware(HardwareName, option, uniqueID) {
    dispatch(deleteSelectedHardware({ HardwareName, option, uniqueID }));
  }

  const filterData = Array.isArray(selectedHardware)
    ? selectedHardware.filter((item) => item.num_options === whichOption)
    : [];

  const totalSelectedCameras = useSelector((state) => {
    const cameras = state.counter1.selectedCamera;
    const filteredCameras = cameras.filter(
      (item) => item.num_options === whichOption
    );
    let total = 0;
    filteredCameras.forEach((item) => {
      if (item.Product_Quantity) {
        total += item.Product_Quantity;
      }
    });
    return total;
  });

  const accessDrops = (drop) => {
    setTotalDrops(drop);
  };

  useEffect(() => {
    let numberOfHardware = 0;

    filterData.forEach((item) => {
      numberOfHardware += item?.Product_Quantity;
    });

    if (whichOption && totalNoOptions !== undefined) {
      dispatch(
        updateComparisonData({
          [whichOption]: {
            name: "hardware",
            quantity: numberOfHardware || 0,
            warning: totalDrops[whichOption] || totalSelectedCameras,
            option: whichOption,
            navigationName: "/hardware",
          },
        })
      );
    }
  }, [filterData]);

  return (
    <>
      <Container fluid className="my-4" style={{ backgroundColor: "" }}>
        <Container className="navbar_margin">
          <Row style={{ backgroundColor: "" }}>
            <Col style={{ backgroundColor: "" }} className="marginTopSpace">
              <h2>
                Hardware <span className="fst-italic fs-6">(Category)</span>
              </h2>
            </Col>
            <Col className="marginTopSpace" style={{ backgroundColor: "" }}>
              <Row>
                <Col className="text-end">
                  Number of Cameras Required:&nbsp;
                  <span className="fw-bold">{selectedCameraNumber}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  Total selected Camera:&nbsp;
                  <span className="fw-bold">{totalSelectedCameras}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  Total number of drops : {}
                  <span className="fw-bold">
                    {totalDrops[whichOption] === undefined
                      ? 0
                      : totalDrops[whichOption] === 0
                      ? totalSelectedCameras
                      : totalDrops[whichOption]}
                  </span>
                  {totalDrops === 0 ? (
                    <DisplayDrops
                      accessDrops={accessDrops}
                      runAccessDrops={"runAccessDrops"}
                    />
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  <Link to="/" style={{ display: "inline-block" }}>
                    <h6>
                      Edit here <span className="fw-bold"></span>
                    </h6>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>

          {/* {selectedHardware && selectedHardware.length > 0 ? ( */}
          <Row className="" style={{ padding: "8px" }}>
            <Col>
              <h5 className="fw-bold">Add to Cart: </h5>

              <div className="table-border">
                <Table striped bordered hover responsive>
                  <colgroup>
                    <col style={{ width: "160px" }} />
                    <col style={{ width: "auto" }} />
                    <col style={{ width: "110px" }} />
                    <col style={{ width: "80px" }} />
                    <col style={{ width: "120px" }} />
                    <col style={{ width: "90px" }} />
                    <col style={{ width: "90px" }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>SKU: </th>
                      <th>Description & Options</th>
                      <th>Price: </th>
                      <th>QTY: </th>
                      <th>Total: </th>
                      <th colSpan={2} className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(selectedHardware) &&
                      selectedHardware
                        .filter((item) => item.num_options === whichOption)
                        .map((selectedHardware, index) => {
                          const calc = calculateLineItem(selectedHardware);
                          return (
                          <tr key={index}>
                            <td style={{ whiteSpace: "nowrap" }}>{getProductSku(selectedHardware)}</td>
                            <td>
                              <strong>{getProductDisplayName(selectedHardware)}</strong>
                              {getOptionEntries(selectedHardware, [
                                "Hardware_Total_data",
                                "HardWare_Base_Price",
                                "HardWare_Final_Price",
                                "Hardware_New_Final_Price",
                                "basePrice3",
                                "test",
                                "existingQuantity",
                                "existingUnitCost",
                                "existingTotalPrice",
                              ])
                                .filter(
                                  (option) =>
                                    option.value !== undefined &&
                                    option.value !== null &&
                                    option.value !== "" &&
                                    typeof option.value !== "object"
                                )
                                .map((option) => (
                                  <React.Fragment key={option.name}>
                                    <br />
                                    <strong>{option.name}:</strong> {String(option.value)}{" "}
                                    <strong>${Number(option.price || 0).toFixed(2)}</strong>
                                  </React.Fragment>
                                ))}
                            </td>
                            <td>${calc.unitTotal.toFixed(2)}</td>
                            <td>{selectedHardware.Product_Quantity}</td>
                            <td>${calc.lineTotal.toFixed(2)}</td>
                            <td>
                              <Button
                                className=""
                                variant="dark"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleButtonClick(
                                    e,
                                    selectedHardware,
                                    "edit",
                                    selectedHardware.uniqueID
                                  );
                                }}
                              >
                                Edit
                              </Button>
                            </td>
                            <td>
                              <Button
                                className=""
                                variant="dark"
                                onClick={() =>
                                  deleteHardware(
                                    selectedHardware.Product_Name,
                                    selectedHardware.num_options,
                                    selectedHardware.uniqueID
                                  )
                                }
                              >
                                Delete
                              </Button>
                            </td>
                          </tr>
                          );
                        })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
          {/* ) : (
        ""
      )} */}

          <div className="d-flex justify-content-end align-items-center">
            {/* Show the warning to the before he moves to the next category */}
            {showWarningComponent ? (
              <WarningComponent
                path="/cabling"
                setShowWarningComponent={setShowWarningComponent}
              />
            ) : (
              ""
            )}
            <Button
              variant="dark"
              onClick={() => setShowWarningComponent(true)}
            >
              Next
            </Button>
          </div>

          <Row className="my-4">
            {hardwareData
              .sort((a, b) => parseInt(a.sorting) - b.sorting)
              .map((hardware) => {
                return (
                  <Col
                    key={hardware.id}
                    style={{ backgroundColor: "" }}
                    md={4}
                    className="nvr_col my-3"
                    onClick={(e) => handleButtonClick(e, hardware, "add")}
                  >
                    <Card style={{ width: "", margin: "" }}>
                      <Card.Body>
                        <Card.Title className="fw-bold">
                          SKU :{hardware.id}
                        </Card.Title>
                        <Card.Text>
                          {hardware.name.split(" ").length > 12
                            ? `${hardware.name
                                .split(" ")
                                .slice(0, 12)
                                .join(" ")}...`
                            : hardware.name}
                        </Card.Text>
                        <Row
                          style={{
                            height: "185px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Col xs={8}>
                            <Card.Img
                              variant="top"
                              style={{
                                width: "100%",
                                height: "100%",
                                maxHeight: "200px",
                                objectFit: "contain",
                                // aspectRatio: "1",
                                border: "0px solid grey",
                              }}
                              src={
                                hardware.thumbnail === ""
                                  ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                  : "https://platinumcctv.com/" +
                                    hardware.thumbnail
                              }
                            />
                          </Col>
                          <Col
                            xs={4}
                            className="d-flex align-items-center justify-content-center fw-bold"
                          >
                            {areYouDealer !== "Dealer Selected"
                              ? hardware.price
                              : hardware.price_2}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </Container>

      {/* Warning Modal */}
      <Modal show={show2} onHide={handleClose2}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>
              Warning! Total Quantity of Hardware is less than Total Number of
              Cameras
            </h6>
          </Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>Are you sure you want to continue?</Modal.Body> */}
        <Modal.Footer>
          <Button variant="dark" onClick={handleClose2}>
            Go Back
          </Button>
          <Button variant="dark" onClick={() => navigate("/special")}>
            Continue Anyways
          </Button>
        </Modal.Footer>
      </Modal>

      {/* {} */}

      <MyVerticallyCenteredModal
        show={modalShow}
        customData={data2}
        onHide={() => setModalShow(false)}
        showButtons={showButtons}
        totalSelectedCameras={totalSelectedCameras}
        productOptionCSVQuery={productOptionCSVQuery}
      />
    </>
  );
}

export default Hardware;
